import PropTypes from 'prop-types';
import classNames from 'classnames';
import { LS_MODULE_HOVER_OVERLAY, LS_UNEDITABLE_HOVER_OVERLAY, NON_LS_MODULE_HOVER_OVERLAY_BLOCKED, NON_LS_MODULE_HOVER_OVERLAY_WITHOUT_ACCESS, NON_LS_MODULE_HOVER_OVERLAY_RICH_TEXT_WITH_MODULES_WITHOUT_ACCESS, NON_LS_MODULE_HOVER_OVERLAY_GLOBAL_GROUP, NON_LS_MODULE_HOVER_OVERLAY_EMBED
// @ts-expect-error untyped module
} from 'ContentEditorUI/lib/layoutSection/dom';
// @ts-expect-error untyped modules
import GlobalContentNoAccessLabel from './GlobalContentNoAccessLabel';
import ModuleNotDraggableLabel from './ModuleNotDraggableLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LayoutSectionHoverOverlay = ({
  id,
  cursor,
  hasContentEmbedAccess,
  hasGlobalContentEditorAccess,
  height,
  isGlobal,
  isUneditable,
  left,
  onClick,
  onMouseDown,
  onMouseUp,
  opacity,
  pointerEvents,
  isFixedPosition,
  top,
  width,
  isAdvancedModuleWithoutAccess,
  isPaymentsModuleWithoutAccess,
  hasPersonalizationTokenWithoutAccess,
  defaultType,
  isEmbed,
  isStaticSectionModule,
  domNodeRef
}) => {
  const styles = {
    top,
    left,
    width,
    height
  };
  if (opacity != null) {
    styles.opacity = opacity;
  }
  if (cursor != null) {
    styles.cursor = cursor;
  }
  if (isFixedPosition) {
    styles.position = 'fixed';
  }
  if (pointerEvents != null) {
    styles.pointerEvents = pointerEvents;
  }
  const isRichTextModule = defaultType === 'rich_text';
  const classes = classNames(LS_MODULE_HOVER_OVERLAY, (isGlobal && !hasGlobalContentEditorAccess || isEmbed && !hasContentEmbedAccess) && NON_LS_MODULE_HOVER_OVERLAY_BLOCKED, (isAdvancedModuleWithoutAccess && !isRichTextModule || isPaymentsModuleWithoutAccess) && NON_LS_MODULE_HOVER_OVERLAY_WITHOUT_ACCESS, (isAdvancedModuleWithoutAccess && isRichTextModule || hasPersonalizationTokenWithoutAccess) && NON_LS_MODULE_HOVER_OVERLAY_RICH_TEXT_WITH_MODULES_WITHOUT_ACCESS, (isAdvancedModuleWithoutAccess || isPaymentsModuleWithoutAccess) && 'hs-clean-lines-without-access-bars', isUneditable && LS_UNEDITABLE_HOVER_OVERLAY, isGlobal && hasGlobalContentEditorAccess && NON_LS_MODULE_HOVER_OVERLAY_GLOBAL_GROUP, isEmbed && hasContentEmbedAccess && NON_LS_MODULE_HOVER_OVERLAY_EMBED, !isAdvancedModuleWithoutAccess && !isPaymentsModuleWithoutAccess && !hasPersonalizationTokenWithoutAccess && 'updated-editor-styles');
  return /*#__PURE__*/_jsxs("div", {
    onClick: onClick,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp,
    className: classes,
    style: styles,
    ref: domNodeRef,
    children: [isGlobal && !hasGlobalContentEditorAccess && /*#__PURE__*/_jsx(GlobalContentNoAccessLabel, {
      height: height,
      width: width
    }), isStaticSectionModule &&
    /*#__PURE__*/
    // The key is for an edge case where two undraggable modules are
    // placed next to each other. When dragging from one of these modules
    // to another, we'll want to remount the overlay so that the
    // useWasDragAttempted state and listeners are reset.
    _jsx(ModuleNotDraggableLabel, {
      height: height,
      width: width
    }, id)]
  });
};
LayoutSectionHoverOverlay.propTypes = {
  id: PropTypes.string.isRequired,
  cursor: PropTypes.string,
  hasContentEmbedAccess: PropTypes.bool.isRequired,
  hasGlobalContentEditorAccess: PropTypes.bool.isRequired,
  height: PropTypes.number.isRequired,
  isGlobal: PropTypes.bool.isRequired,
  isUneditable: PropTypes.bool,
  left: PropTypes.number.isRequired,
  top: PropTypes.number.isRequired,
  isFixedPosition: PropTypes.bool,
  width: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  onMouseUp: PropTypes.func,
  onMouseDown: PropTypes.func,
  opacity: PropTypes.number,
  pointerEvents: PropTypes.string,
  isAdvancedModuleWithoutAccess: PropTypes.bool.isRequired,
  isPaymentsModuleWithoutAccess: PropTypes.bool,
  hasPersonalizationTokenWithoutAccess: PropTypes.bool,
  defaultType: PropTypes.string,
  isEmbed: PropTypes.bool,
  isStaticSectionModule: PropTypes.bool,
  domNodeRef: PropTypes.any
};
export default LayoutSectionHoverOverlay;